export enum AdminUserRoutes {
  BasePrefix = "user",
  RecoverUser = "recover-user"
}
